import React from "react";
import "./styles.scss";
import {
  FILTER_BY_BRAND,
  FILTER_BY_LOCK_STATUS,
  FILTER_BY_STATUS,
} from "../../../constants/filterConst";
import FilterDialog from "../filter";
import FilterItem from "../filterItem";

function BikeFilter(props) {
  const {
    visible,
    hideFilter,
    changeSelectorValue,
    apply,
    cancel,
    filterProps,
    statuses = [],
    brands = [],
    lockStatuses = [],
  } = props;

  const handleChangeSelectorValue = (filter, filterBy) =>
    changeSelectorValue(filter, filterBy);

  return (
    <FilterDialog
      visible={visible}
      hideDialog={hideFilter}
      apply={apply}
      cancel={cancel}
      body={
        <>
          <FilterItem
            filterBy={FILTER_BY_STATUS}
            changeSelectorValue={handleChangeSelectorValue}
            selectorItems={statuses.map((item, index) => ({
              id: index,
              name: item,
            }))}
            filterProps={filterProps}
          />
          <FilterItem
            filterBy={FILTER_BY_BRAND}
            changeSelectorValue={handleChangeSelectorValue}
            selectorItems={brands.map((item, index) => ({
              id: index,
              name: item,
            }))}
            filterProps={filterProps}
          />
          <FilterItem
            filterBy={FILTER_BY_LOCK_STATUS}
            changeSelectorValue={handleChangeSelectorValue}
            selectorItems={lockStatuses.map((item, index) => ({
              id: index,
              name: item,
            }))}
            filterProps={filterProps}
          />
        </>
      }
    />
  );
}

export default BikeFilter;
